import React from 'react';
export function StudentTableSkeleton({
  rows = 6
}: {
  rows?: number;
}) {
  return <div className="p-4" aria-busy="true" aria-live="polite" data-id="element-409" data-mp="el63b3nqy12v">
      <span className="sr-only" data-id="element-410" data-mp="emqtkh312xux">Loading student records…</span>
      <div className="hidden md:block" data-id="element-411" data-mp="moj3fx1v6pp">
        <div className="mb-3 flex items-center gap-4 px-2" data-id="element-412" data-mp="nr9lmqgn753">
          {[26, 10, 12, 18, 18, 14].map((width, index) => <div key={index} className="shimmer h-3 rounded-full" style={{
          width: `${width}%`
        }} data-id="element-413" data-mp="tac1qperfn9p" data-mpi={index} />)}
        </div>
        {Array.from({
        length: rows
      }).map((_, rowIndex) => <div key={rowIndex} className="flex items-center gap-4 border-t border-[var(--glass-hairline)] px-2 py-4" style={{
        opacity: 1 - rowIndex * 0.08
      }} data-id="element-414" data-mp="yb80kok98j89" data-mpi={rowIndex}>
            <div className="shimmer h-9 w-9 shrink-0 rounded-xl" data-id="element-415" data-mp="1c96fbv2hmhoa" />
            <div className="flex-1 space-y-2" data-id="element-416" data-mp="1c7v9lpphezuj">
              <div className="shimmer h-3 w-1/3 rounded-full" data-id="element-417" data-mp="1h0en6mo65uzc" />
              <div className="shimmer h-2.5 w-1/4 rounded-full" data-id="element-418" data-mp="1h1zjagq4tlzb" />
            </div>
            <div className="shimmer h-3 w-16 rounded-full" data-id="element-419" data-mp="fo6jmt8hwf9o" />
            <div className="shimmer h-3 w-24 rounded-full" data-id="element-420" data-mp="apmwwqm2uzg9" />
            <div className="shimmer h-3 w-32 rounded-full" data-id="element-421" data-mp="an0qwveu4s05" />
            <div className="shimmer h-8 w-8 rounded-lg" data-id="element-422" data-mp="oh1r7tlfqn2m" />
          </div>)}
      </div>

      <div className="space-y-3 md:hidden" data-id="element-423" data-mp="joqgrwt2jivt">
        {Array.from({
        length: 4
      }).map((_, index) => <div key={index} className="rounded-2xl border border-[var(--glass-hairline)] p-4" data-id="element-424" data-mp="yd4retwq8bmx" data-mpi={index}>
            <div className="flex items-center gap-3" data-id="element-425" data-mp="tejqstdkbpxy">
              <div className="shimmer h-11 w-11 rounded-xl" data-id="element-426" data-mp="17f481l3txdpc" />
              <div className="flex-1 space-y-2" data-id="element-427" data-mp="17ebclgabmami">
                <div className="shimmer h-3 w-2/3 rounded-full" data-id="element-428" data-mp="13czjv1w5h9a3" />
                <div className="shimmer h-2.5 w-1/3 rounded-full" data-id="element-429" data-mp="13bernixb62fe" />
              </div>
            </div>
            <div className="mt-4 space-y-2" data-id="element-430" data-mp="398ambx7sojx3">
              <div className="shimmer h-2.5 w-full rounded-full" data-id="element-431" data-mp="355xhrc4sas1w" />
              <div className="shimmer h-2.5 w-4/5 rounded-full" data-id="element-432" data-mp="1849kdl5tvj8o" />
            </div>
          </div>)}
      </div>
    </div>;
}